import { render, staticRenderFns } from "./DropdownEl.vue?vue&type=template&id=1b090920&"
import script from "./DropdownEl.vue?vue&type=script&lang=ts&"
export * from "./DropdownEl.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownEl.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
